import DOMPurify from 'dompurify';

export const sanitizeEmailHtml = (rawHtml: string): string => {
  if (!rawHtml) return '';
  return DOMPurify.sanitize(rawHtml, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select'],
    FORBID_ATTR: ['style'],
    ALLOW_UNKNOWN_PROTOCOLS: false,
    ADD_ATTR: ['target', 'rel'],
  });
};
